import LoLFlowController from './LoLFlowController';

export default LoLFlowController;
